module.exports = __webpack_public_path__ + "img/android-chrome-512x512-AJT.78428953.png";